/* eslint-disable @typescript-eslint/no-unused-vars */
import App from 'App';
import MainLayout from 'layouts/MainLayout';
import Error404 from 'pages/error/Error404';
import SimpleTwoFA from 'pages/thermography/auth/TwoFA';
import SplitForgotPassword from 'pages/thermography/auth/ForgotPassword';
import SplitLockScreen from 'pages/thermography/auth/LockScreen';
import SplitResetPassword from 'pages/thermography/auth/ResetPassword';
import SplitSignIn from 'pages/thermography/auth/SignIn';
import SplitSignOut from 'pages/thermography/auth/SignOut';
import SplitSignUp from 'pages/thermography/auth/SignUp';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import { lazy } from 'react';
import { RouteObject, createBrowserRouter, Navigate } from 'react-router-dom';
import PrivateRoute from 'components/PrivateRoute';

const FontAwesomeExample = lazy(
	() => import('pages/modules/components/FontAwesomeExample')
);

const FeatherIconsExample = lazy(
	() => import('pages/modules/components/FeatherIconsExample')
);

const UniconsExample = lazy(
	() => import('pages/modules/components/UniconsExample')
);

//*************************** Componentes Termografia ************************/
import InspectionRouteForm from 'pages/thermography/InspectionRouteForm';
import PowerStations from 'pages/thermography/PowerStations';
import ThermalAnomalyForm from 'pages/thermography/ThermalAnomalyForm';
import InspectionRoutes from 'pages/thermography/InspectionRoute/InspectionRoutes';
import InspectionRecordForm from 'pages/thermography/InspectionRecord/InspectionRecordForm';
import InspectionRecordsTable from 'pages/thermography/InspectionRecord/InspectionRecordsTable';
import ThermographicInspectionRecordReportPage from 'pages/thermography/Reports/ThermographicInspectionRecord/ThermographicInspectionRecordReportPage';
import InspectionRecordReportPage from 'pages/thermography/Reports/InspectionRecord/InspectionRecordReportPage';
import DataImportWizard from 'pages/thermography/DataImportWizard/DataImportWizard';

const routes: RouteObject[] = [
	{
		element: <App />,
		children: [
			{
				element: <PrivateRoute />,
				children: [
					{
						path: '/',
						element: (
							<MainLayoutProvider>
								<MainLayout />
							</MainLayoutProvider>
						),
						children: [
							{
								index: true,
								element: <PowerStations />
							}
						]
					},
					{
						path: 'inspectionRoutes',
						element: (
							<MainLayoutProvider>
								<MainLayout />
							</MainLayoutProvider>
						),
						children: [
							{
								index: true,
								element: <InspectionRoutes />
							},
						]
					},
					{
						path: 'inspectionRecords',
						element: (
							<MainLayoutProvider>
								<MainLayout />
							</MainLayoutProvider>
						),
						children: [
							{
								index: true,
								element: <InspectionRecordsTable />
							},
							{
								path: "view/:id",
								element: <InspectionRecordForm mode="view" />
							},
							{
								path: ":id",
								element: <InspectionRecordForm mode="edit" />
							},
							{
								path: 'report/:id',
								element: <InspectionRecordReportPage />
							}
						]
					},
					{
						path: 'thermalAnomalyForm',
						children: [
							{
								path: 'new',
								element: <ThermalAnomalyForm mode="new" />
							},
							{
								path: "new_trr/:plantId/:equipmentId/:routeId",
								element: <ThermalAnomalyForm mode="new_trr" />
							},
							{
								path: 'view/:codigo',
								element: <ThermalAnomalyForm mode="view" />
							},
							{
								path: 'edit/:codigo',
								element: <ThermalAnomalyForm mode="edit" />
							},
							{
								path: 'edit_trr/:codigo',
								element: <ThermalAnomalyForm mode="edit_trr" />
							}
						]
					},
					{
						path: 'inspectionrouteForm',
						children: [
							{
								path: 'new',
								element: <InspectionRouteForm mode="new" />
							},
							{
								path: 'view/:codigo',
								element: <InspectionRouteForm mode="view" />
							},
							{
								path: 'edit/:codigo',
								element: <InspectionRouteForm mode="edit" />
							}
						]
					},
					{
						path: 'thermalRecordForm',
						children: [
							{
								path: 'new',
								element: <ThermalAnomalyForm mode="new" />
							},
							{
								path: 'view/:codigo',
								element: <ThermalAnomalyForm mode="view" />
							},
							{
								path: 'edit/:codigo',
								element: <ThermalAnomalyForm mode="edit" />
							},
							{
								path: 'report/:codigo',
								element: <ThermographicInspectionRecordReportPage />
							}
						]
					},
					{
						path: 'dataImport',
						element: (
							<MainLayoutProvider>
								<MainLayout />
							</MainLayoutProvider>
						),
						children: [
							{
								index: true,
								element: <DataImportWizard />
							},
						]
					},
				]
			},
			{
				path: 'auth',
				children: [
					{
						path: 'login',
						element: <SplitSignIn />
					},
					{
						path: 'criar-conta',
						element: <SplitSignUp />
					},
					{
						path: 'logout',
						element: <SplitSignOut />
					},
					{
						path: 'esqueci-senha',
						element: <SplitForgotPassword />
					},
					{
						path: 'redefinir-senha',
						element: <SplitResetPassword />
					},
					{
						path: 'lock-screen',
						element: <SplitLockScreen />
					},
					{
						path: '2FA',
						element: <SimpleTwoFA />
					}
				]
			},
			{
				path: '*',
				element: <Error404 />
			}
		]
	}
];

export const router = createBrowserRouter(routes, {
	future: {
		// v7_startTransition: true,
		v7_relativeSplatPath: true,
	},
});
export default routes;
